import ImporteField, { interpretarImporte } from "./ImporteField";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDataContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { getPaymentInformation, paymentTF } from "../../services/api";
import Swal from "sweetalert2";
import dashboardStyle from "../../styles/Dashboard.module.css";
import transferImage from "../../images/comprobantes ui-tansferencia.png";
import PaymentReportForm, {
  PaymentField,
  PaymentModalLoader,
  PaymentStaticField,
} from "./PaymentReportForm";

export default function TransferenciaBancaria({ toggleModal3 }) {
  const navigate = useNavigate();
  const { contextData } = useDataContext();
  const customerId = contextData?.customer?.id;
  const orderId = contextData?.customer?.order_id;

  const [selectedDate, setSelectedDate] = useState(null);
  const [digitos, setDigitos] = useState("");
  const banco = "Banco Nación";
  const [amount, setAmount] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const singlePayment = 0;
  const paymentStatus = 0;
  const [amountError, setAmountError] = useState("");
  const [digitosError, setDigitosError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!customerId || !orderId) {
      setLoading(false);
      return;
    }

    let ignore = false;
    const fetchPaymentInformation = async () => {
      try {
        const data = await getPaymentInformation(customerId, orderId);
        if (!ignore) {
          setPaymentMethod(data.payment_method_number);
          setPaymentType(data.payment_type);
          setLoading(false);
        }
      } catch (error) {
        console.log(`Error en la solicitud de información de pago: ${error.message}`);
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    fetchPaymentInformation();

    return () => {
      ignore = true;
    };
  }, [customerId, orderId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const monto = interpretarImporte(amount) ?? 0;
      if (monto <= 100) {
        setAmountError("El monto debe ser mayor que 100");
        return;
      }
      setAmountError("");

      if (!/^\d{4}$/.test(digitos)) {
        setDigitosError("Debe ingresar 4 dígitos");
        return;
      }
      setDigitosError("");

      if (isSubmitting) {
        return;
      }

      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("selectedDate", selectedDate);
      formData.append("amount", monto);
      formData.append("nombre", "");
      formData.append("digitos", digitos);
      formData.append("banco", banco);
      formData.append("paymentMethod", paymentMethod);
      formData.append("paymentType", paymentType);
      formData.append("singlePayment", singlePayment);
      formData.append("paymentStatus", paymentStatus);
      formData.append("archivoAdjunto", file);
      formData.append("customer", customerId);
      formData.append("order_id", orderId);

      const response = await paymentTF(formData, customerId);

      if (response.ok) {
        await response.json();
        navigate("/correcto");
      } else {
        await response.json();
        Swal.fire({
          icon: "error",
          iconColor: "#d54ab7",
          confirmButtonColor: "#0071ce",
          title: "Error al crear el pago",
          text: "Por favor, inténtelo de nuevo más tarde.",
        });
      }
    } catch (error) {
      console.error("Error al crear el pago:", error);
      Swal.fire({
        icon: "error",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Error al crear el pago",
        text: "Por favor, inténtelo de nuevo más tarde.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileInputChange = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  if (loading) {
    return <PaymentModalLoader />;
  }

  const amountInlineError = amountError;

  return (
    <PaymentReportForm
      methodName="Transferencia bancaria"
      methodDescription="Completá los últimos datos de la operación y subí el comprobante para que podamos ubicarla enseguida."
      illustrationSrc={transferImage}
      illustrationAlt="Referencia visual del comprobante para transferencia bancaria"
      file={file}
      fileInputRef={fileInputRef}
      onFileChange={handleFileInputChange}
      onClose={toggleModal3}
      onSubmit={handleSubmit}
      submitDisabled={!file || isSubmitting}
      submitLabel={isSubmitting ? "Enviando..." : "Enviar informe"}
      uploadHint="Intentá que se vea completa la transferencia y el detalle de la cuenta destino."
      uploadRequiredText="Subí el comprobante para poder enviar el informe."
    >
      <PaymentField label="Fecha de pago">
        <DatePicker
          placeholderText="Fecha del comprobante"
          className={dashboardStyle.paymentInput}
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="dd/MM/yyyy"
          maxDate={new Date()}
          required
        />
      </PaymentField>

      <PaymentField label="Últimos 4 dígitos" error={digitosError}>
        <input
          className={dashboardStyle.paymentInput}
          type="number"
          value={digitos}
          onChange={(e) => setDigitos(e.target.value)}
          pattern="[0-9]*"
          required
        />
      </PaymentField>

      <PaymentStaticField
        label="Cuenta destino"
        value={banco}
        hint="Es la cuenta de referencia que usamos para identificar la transferencia."
      />

      <PaymentField label="Importe" error={amountInlineError}>
        <ImporteField value={amount} onChange={setAmount} className={dashboardStyle.paymentInput} />
      </PaymentField>
    </PaymentReportForm>
  );
}
